import React from 'react'
import PropTypes from 'prop-types'
import './Headline.scss'
import { classNames } from '../../helpers/classNames'

/* eslint-disable react/no-danger */
function Headline({ data, grid, embed }) {
  const { headerText, textAlignment, preHeaderText, subtext } = data
  const alignment = (textAlignment ?? '').toLowerCase() || 'center'
  return (
    <section
      className={classNames(
        'Headline',
        `${data.backgroundColor?.toLowerCase()} text-${alignment} ${data.style ?? ''}`,
        {
          'people-use--grid': grid,
          'people-use': !grid,
          embed
        }
      )}
    >
      <div className="container__inner">
        <h5 className="pre-heading">{preHeaderText}</h5>
        <h4
          className={classNames('people-use__header heading-sub-bold', {
            'grid-header heading-section--grid-title': grid,
            'heading-section': !grid
          })}
        >
          {headerText}
        </h4>
        {subtext?.subtext ? (
          <p
            className={classNames('leadership__text general-text', {
              'general-text--grid': grid
            })}
          >
            {subtext.subtext}
          </p>
        ) : null}
      </div>
    </section>
  )
}

Headline.defaultProps = {
  grid: false,
  embed: false
}

Headline.propTypes = {
  data: PropTypes.object.isRequired,
  grid: PropTypes.bool,
  embed: PropTypes.bool
}

export { query as data } from './headlineQuery'

export default Headline
